import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { InvoiceBrandColorSection } from "@/components/features/company-image/InvoiceBrandColorSection";

export interface BrandColorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Row this colour belongs to — the marca's name, or the razón social. */
  title: string;
  /** Logo the colour suggestions are sampled from. */
  logoUrl: string | null;
  savedColor: string | null;
  saving: boolean;
  onSave: (brandColor: string | null) => void;
}

/**
 * Brand colour, as its own action on a row.
 *
 * One dialog for every row in the Marcas list — a marca or the legal entity —
 * so "where do I change the colour?" has a single answer. It used to be buried
 * inside each row's edit dialog, which made it findable only by opening
 * something labelled for a different job.
 */
export function BrandColorDialog({
  open,
  onOpenChange,
  title,
  logoUrl,
  savedColor,
  saving,
  onSave,
}: BrandColorDialogProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {t(
              "brands.colorDialogHelp",
              "Se usa en los encabezados de la factura PDF, con texto blanco encima."
            )}
          </DialogDescription>
        </DialogHeader>
        {/* chromeless: the dialog supplies the title and the explanation, so
            the panel drops its own and puts its actions in a footer. */}
        <InvoiceBrandColorSection
          chromeless
          logoUrl={logoUrl}
          savedColor={savedColor}
          saving={saving}
          onSave={onSave}
        />
      </DialogContent>
    </Dialog>
  );
}
